import { ISRESULT } from "../actions/actionsTypes";

const isResultReducer = (isResult = false, actions) => {
    switch (actions.type) {
        case ISRESULT:
            return {...isResult,isResult: actions.isResult};
        default:
            return {...isResult,isResult: false};
    }
}

export default isResultReducer;